import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, X } from "lucide-react";

const inp = "w-full h-11 px-3 border border-zinc-300 bg-white text-base text-[#0F172A] outline-none focus:border-[#D4AF37]";

export function EditContactSheet({ customer, onClose, onSaved }) {
  const [f, setF] = useState({ contact_name: customer.contact_name || "", phone: customer.phone || "", email: customer.email || "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch(`/crm/customers/${customer.id}`, { contact_name: f.contact_name.trim(), phone: f.phone.trim(), email: f.email.trim() });
      toast.success("Contact updated");
      onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not save");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-[#0F172A]/60 flex items-end" onClick={onClose} data-testid="m-edit-contact-sheet">
      <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="w-full bg-white max-h-[92dvh] overflow-y-auto animate-in slide-in-from-bottom duration-200" style={{ paddingBottom: "max(env(safe-area-inset-bottom), 16px)" }}>
        <div className="sticky top-0 bg-white flex items-center justify-between px-4 py-3 border-b border-zinc-200">
          <h3 className="font-display font-bold text-lg text-[#0F172A]">Edit contact</h3>
          <button type="button" onClick={onClose} data-testid="m-edit-contact-close" className="p-1 text-zinc-400"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-4 space-y-3">
          <label className="block text-xs text-zinc-500">Contact name
            <input value={f.contact_name} onChange={set("contact_name")} autoComplete="name" data-testid="m-edit-contact-name" className={`${inp} mt-1`} />
          </label>
          <label className="block text-xs text-zinc-500">Phone
            <input type="tel" value={f.phone} onChange={set("phone")} autoComplete="tel" data-testid="m-edit-contact-phone" className={`${inp} mt-1`} />
          </label>
          <label className="block text-xs text-zinc-500">Email
            <input type="email" value={f.email} onChange={set("email")} autoComplete="email" autoCapitalize="none" data-testid="m-edit-contact-email" className={`${inp} mt-1`} />
          </label>
          <button type="submit" disabled={saving} data-testid="m-edit-contact-save" className="w-full h-12 bg-[#0F172A] text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
            {saving && <Loader2 className="h-4 w-4 animate-spin" />} Save contact
          </button>
        </div>
      </form>
    </div>
  );
}
